// Import utils
import { getDocumentElements, getDocumentElement, updateFieldTotal } from "../../Utils/Utils";

/**
 * Callback function to execute when mutations are observed. This will
 * only fire the calculation if we notice a change in the childlist nodes.
 * 
 * @param       {array}     mutationList
 * 
 * @returns     {void}
 */
const RoofSurfaceCalcChildNodeObserver = (mutationList) => {
    mutationList.forEach(mutation => {
        if (mutation.type === "childList") {
            RoofSurfaceCalc(true);
        }
    });
};

/**
 * Set the childlist mutation observer.
 * 
 * @returns     {void}
 */
const SetRoofSurfaceCalcMutationObserver = () => {
    const Accordion = getDocumentElement('#roof-surfaces');
    const ObserverConfig = { childList: true, subtree: true };

    const Observer = new MutationObserver(RoofSurfaceCalcChildNodeObserver);
    Observer.observe(Accordion, ObserverConfig);
};

/**
 * Run the calculation for the roof surface area.
 * 
 * Calculation shown below  (answer will be in Megalitres)
 * (R x A x F) ÷ 1,000,000
 * 
 * KEY
 * R = Annual rainfall (millimetre)
 * A = Area of roof (square metre)
 * F = 0.95 (the factor to account for evaporation and splashing)
 * 
 * @param       {HTMLElement} roofSurfaceField 
 * @param       {HTMLELement} megaLField 
 * 
 * @returns     {void}
 */
const RoofCalcHandler = (roofSurfaceField, megaLField) => {
    const RoofSurfaceValue = roofSurfaceField.value;
    const ZoneRainfallValue = parseInt(getDocumentElement('#rainfall').value);
    const EvaporationSplashingFactor = 0.95;
    let calcValue = 0;

    if (ZoneRainfallValue > 0) {
        calcValue = ZoneRainfallValue * RoofSurfaceValue * EvaporationSplashingFactor / 1000000;
        megaLField.value = calcValue.toFixed(3);
    }
};

/**
 * This watches the sub total fields for value changes. It calls for an update
 * on the total water use. If we have already mounted the eventlisteners, ignore
 * the mutationobserver setup.
 * 
 * @param       {boolean}   mounted
 * 
 * @returns     {void}
 */
export const RoofSurfaceCalc = (mounted) => {
    const RoofSurfaceMegaLTotalField = getDocumentElement('#roofTotal');
    const RoofSummaryTotalField = getDocumentElement('#tot_roof');
    const RoofSurfaceMegaLFields = getDocumentElements('#roof-surfaces [id^="roofSubtotal"]');
    const RoofAreaFields = getDocumentElements('#roof-surfaces [id^="roofArea"]');

    if (RoofSurfaceMegaLFields && RoofSurfaceMegaLTotalField && RoofAreaFields) {
        if (mounted === false) {
            SetRoofSurfaceCalcMutationObserver();
        }

        RoofAreaFields.forEach((field, index) => {
            field.addEventListener('input', e => {
                e.stopImmediatePropagation();

                RoofCalcHandler(field, RoofSurfaceMegaLFields[index]);
                updateFieldTotal(RoofSurfaceMegaLFields, RoofSurfaceMegaLTotalField, RoofSummaryTotalField);
            });
        });

        RoofSurfaceMegaLFields.forEach(field => {
            field.addEventListener('input', e => {
                e.stopImmediatePropagation();

                updateFieldTotal(RoofSurfaceMegaLFields, RoofSurfaceMegaLTotalField, RoofSummaryTotalField);
            });
        });
    }

    // listen for clone removed and re-update totals
    document.addEventListener('clonable:removed', e => {
        if (e.detail.id === 'roof-surface') {
            updateFieldTotal(RoofSurfaceMegaLFields, RoofSurfaceMegaLTotalField, RoofSummaryTotalField);
        }
    });
};
